// extracted by mini-css-extract-plugin
module.exports = {"alert":"i1","alertIcon":"i2","formContainer":"i3","formContainerInner":"i4","successIcon":"i5","footer":"i6","footerItem":"i7"};